// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_iBD","controls":"styles_controls__K6vjj","charLimit":"styles_charLimit__1yoJR","input":"styles_input__1Xa10","send":"styles_send__2YB8j"};